import NumberRange from "./NumberRange";

export default NumberRange;